import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ti-link',
  template: ` <a [href]="href" [target]="target" [title]="title">
    {{ text }}
    <span *ngIf="iconCls" [class]="iconCls"></span>
  </a>`,
})
export class LinkComponent {
  @Input() public href: string;
  @Input() public target: string;
  @Input() public text: string;
  @Input() public iconCls: string;
  @Input() public title: string;
}
